/* eslint-disable react/prop-types */
import { FiArrowDownLeft, FiArrowUpRight } from "react-icons/fi";
import { IoIosSearch } from "react-icons/io";
import { FaRegEye } from "react-icons/fa";
import React, { useState, useEffect } from "react";
import "./Table.css";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../axiosinstance";
import Pagination from "../Components/Pagination";
import { TbCurrencyRupee } from "react-icons/tb";
import SearchableDropdown from "../Components/SearchableDropdown";


function LedgerTable({ isSidebarExpanded }) {
  const [ledgerData, setLedgerData] = useState([]);
  const [totals, setTotals] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [financialYears, setFinancialYears] = useState([]);
  const [selectedFY, setSelectedFY] = useState("");
  const [fyLoading, setFyLoading] = useState(false);
  const [fyError, setFyError] = useState("");
  const [hasLoadedFinancialYears, setHasLoadedFinancialYears] =
    useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const navigate = useNavigate();

  const fetchLedgerData = async (
    query = searchQuery.trim(),
    fyId = selectedFY,
    page = currentPage,
    perPage = itemsPerPage
  ) => {
    setLoading(true);
    setError("");

    try {
      const isSearching = query !== "";
      const selectedFYObj = financialYears.find((fy) => fy.id === fyId);

      const url = isSearching ? `/api/search_ledger` : `/api/get_ledger/v2`;

      const params = isSearching
        ? { query,
           page,
            per_page: perPage,
            ...(selectedFYObj?.start_date
              ? { fy_start: selectedFYObj.start_date }
              : {}),
            ...(selectedFYObj?.end_date
              ? { fy_end: selectedFYObj.end_date }
              : {})
         }
        : {
            page,
            per_page: perPage,
            ...(selectedFYObj?.start_date
              ? { fy_start: selectedFYObj.start_date }
              : {}),
            ...(selectedFYObj?.end_date
              ? { fy_end: selectedFYObj.end_date }
              : {}),
          };

      const response = await axiosInstance.get(url, { params });
      const rows = response.data.data || [];
      const pagination = response.data.pagination || {};

      setLedgerData(rows);
      setCurrentPage(pagination.page || page);
      setItemsPerPage(pagination.per_page || perPage);
      setTotalRecords(pagination.total_records || rows.length || 0);
      setTotalPages(pagination.total_pages || 0);

      if (response.data.result && response.data.result[0]) {
        setTotals(response.data.result[0]);
      } else {
        setTotals({});
      }
    } catch (err) {
      console.error("Error fetching ledger data:", err);
      setError("Failed to fetch ledger data. Please try again.");
      setLedgerData([]);
      setTotals({});
      setTotalRecords(0);
      setTotalPages(0);
    } finally {
      setLoading(false);
    }
  };

  const fetchFinancialYears = async () => {
    setFyLoading(true);
    setFyError("");

    try {
      const response = await axiosInstance.get(`/api/financial-years`);
      const list = Array.isArray(response?.data?.data) ? response.data.data : [];

      if (list.length > 0) {
        const activeFinancialYear =
          list.find((financialYear) => financialYear.is_active) || list[0];
        setFinancialYears(list);
        setSelectedFY(activeFinancialYear?.id ?? "");
      } else {
        setFinancialYears([]);
        setSelectedFY("");
      }
    } catch (err) {
      console.error("Error fetching financial years:", err);
      setFyError("Failed to fetch financial years.");
      setFinancialYears([]);
      setSelectedFY("");
    } finally {
      setFyLoading(false);
      setHasLoadedFinancialYears(true);
    }
  };

  const handleSearch = async (e) => {
    const query = e.target.value;
    setSearchQuery(query);

   
      if (!query.trim()) {
    setCurrentPage(1);
    return fetchLedgerData("", selectedFY, 1, itemsPerPage);
  }
    

    try {
      setLoading(true);
      setError("");
      
      const selectedFYObj = financialYears.find((fy) => fy.id === selectedFY);
      
      
     
         const response = await axiosInstance.get(`/api/search_ledger`, {
        params: { query,
           page:currentPage,
            per_page: itemsPerPage,
            ...(selectedFYObj?.start_date
              ? { fy_start: selectedFYObj.start_date }
              : {}),
            ...(selectedFYObj?.end_date
              ? { fy_end: selectedFYObj.end_date }
              : {}),
         },
      });

      const searchResults = response.data.data || [];
      setLedgerData(searchResults);
      setCurrentPage(1);
      setTotalRecords(searchResults.length);
      setTotalPages(searchResults.length > 0 ? 1 : 0);

      if (response.data.result && response.data.result[0]) {
        setTotals(response.data.result[0]);
      } else {
        setTotals({});
      }
    } catch (error) {
      console.error("Error fetching search results:", error.message);
      setError("Failed to search. Please try again.");
      setLedgerData([]);
      setTotals({});
      setTotalRecords(0);
      setTotalPages(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFinancialYears();
  }, []);

  useEffect(() => {
    if (!hasLoadedFinancialYears) return;
    
  // ✅ Always call with latest query
  fetchLedgerData(searchQuery, selectedFY, currentPage, itemsPerPage);
  }, [
    selectedFY,
    currentPage,
    itemsPerPage,
    hasLoadedFinancialYears,
    searchQuery,
  ]);

  const handlePaginationChange = (page, perPage) => {
    if (searchQuery.trim() !== "") return;
    if (perPage !== itemsPerPage) {
      setItemsPerPage(perPage);
      setCurrentPage(1);
      return;
    }

    if (page !== currentPage) {
      setCurrentPage(page);
    }
  };

  const handleViewLedger = (client_id) => {
    const selectedFYObj = financialYears.find((fy) => fy.id === selectedFY);
    const searchParams = new URLSearchParams();

    if (selectedFYObj?.start_date) {
      searchParams.set("fy_start", selectedFYObj.start_date);
    }
    if (selectedFYObj?.end_date) {
      searchParams.set("fy_end", selectedFYObj.end_date);
    }

    const queryString = searchParams.toString();
    navigate(
      `/view-Ledger/${client_id}${queryString ? `?${queryString}` : ""}`
    );
  };

  function formatNumbers(number) {
    if (number === null || number === undefined || isNaN(number)) return "N/A";

    return new Intl.NumberFormat("en-IN", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 0,
    }).format(number);
  }

  return (
    <div
      className={`table-container ledger-page-layout ledger-management-page ${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div className="table-container-content ledger-panel-content">
        <div className="table-header">
          <div className="table-header-content">
            <div className="table-left-side">
              <h2 className="jost-bold">Ledger Management</h2>
            </div>
            <div className="table-right-side">
              <div className="ledger-filters-row">
                <div className="fy-filter-container">
                  <span className="fy-filter-title">Financial Year</span>
                  <SearchableDropdown
                    value={selectedFY}
                    onChange={(option) => {
                      setCurrentPage(1);
                      setSelectedFY(option ? option.id : "");
                    }}
                    options={financialYears}
                    getOptionValue={(fy) => fy.id}
                    getOptionLabel={(fy) => fy.fy_label}
                    placeholder="Select FY"
                    searchPlaceholder="Search financial year"
                    disabled={
                      fyLoading || !!fyError || financialYears.length === 0
                    }
                  />
                </div>
                <div className="search-bar-container">
                  <input
                    type="text"
                    placeholder="Search ..."
                    className="search-bar"
                    value={searchQuery}
                    onChange={handleSearch}
                  />
                  <IoIosSearch className="search-bar-icon" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="dashboard ledger-summary-dashboard">
          <div className="cards-client ledger-summary-cards">
            <div className="card-client ledger-summary-card ledger-summary-balance">
              <span className="ledger-summary-icon" aria-hidden="true">
                {/* <TbCurrencyRupee /> */}
                <TbCurrencyRupee />
              </span>
              <div className="ledger-summary-copy">
                <p className="title">Total Balance</p>
                <h3>
                  {formatNumbers(Number(totals.total_outstanding_sum || 0))}
                </h3>
              </div>
            </div>
            <div className="card-client card-text-two ledger-summary-card ledger-summary-debit">
              <span className="ledger-summary-icon" aria-hidden="true">
                <FiArrowUpRight />
              </span>
              <div className="ledger-summary-copy">
                <p className="title">Total Debit</p>
                <h3>{formatNumbers(Number(totals.total_debit_sum || 0))}</h3>
              </div>
            </div>
            <div className="card-client dark ledger-summary-card ledger-summary-credit">
              <span className="ledger-summary-icon" aria-hidden="true">
                <FiArrowDownLeft />
              </span>
              <div className="ledger-summary-copy">
                <p className="title">Total Credit</p>
                <h3>{formatNumbers(Number(totals.total_credit_sum || 0))}</h3>
              </div>
            </div>
          </div>
        </div>

        <div className="data-list-body ledger-data-list-body pb0">
          <div className="data-list-scroll-body ledger-scroll-body">
            {loading ? (
              <p>Loading...</p>
            ) : error ? (
              <p className="error-message">{error}</p>
            ) : ledgerData.length > 0 ? (
              <table className="table multilevel-data df-txt-left">
                <colgroup>
                  <col className="ledger-col-sr" />
                  <col className="ledger-col-company" />
                  <col className="ledger-col-debit" />
                  <col className="ledger-col-credit" />
                  <col className="ledger-col-outstanding" />
                  <col className="ledger-col-action" />
                </colgroup>
                <thead className="sticky-header">
                  <tr className="table-row remove-border">
                    <th className="center-align">Sr. No</th>
                    <th
                      style={{
                        textAlign: "left",
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      Client Company Name
                    </th>
                    <th className="price-left-align">Total Debit</th>
                    <th className="price-left-align">Total Credit</th>
                    <th className="price-left-align">Outstanding</th>
                    <th className="center-align">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {ledgerData.map((ledger, index) => (
                    <tr className="hoverable-row" key={ledger.client_id}>
                      <td className="center-align">
                        {(currentPage - 1) * itemsPerPage + index + 1}
                      </td>
                      <td className="">
                        {ledger.client_company_name
                          .toLowerCase()
                          .split(" ")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() + word.slice(1)
                          )
                          .join(" ")}
                      </td>

                      <td className="center-align price-left-align ledger-debit-cell">
                        <span className="ledger-amount-badge ledger-debit-badge">
                          {formatNumbers(Number(ledger.total_debit))}
                        </span>
                      </td>

                      <td className="center-align price-left-align ledger-credit-cell">
                        <span className="ledger-amount-badge ledger-credit-badge">
                          {formatNumbers(Number(ledger.total_credits))}
                        </span>
                      </td>

                      <td className="center-align price-left-align">
                        <span className="ledger-outstanding-text">
                          {formatNumbers(Number(ledger.outstanding_balance))}
                        </span>
                      </td>

                      <td className="center-align">
                        <div
                          className="action-btn"
                          onClick={() => handleViewLedger(ledger.client_id)}
                        >
                          <span className="action-icon">
                            <FaRegEye color="gray" />
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>Currently, there are no records to display</p>
            )}
          </div>

          <Pagination
            className="ledger-pagination"
            showPerPage={100}
            total={totalRecords}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            totalPages={totalPages}
            onPaginationChange={handlePaginationChange}
          />
        </div>
      </div>
    </div>
  );
}

export default LedgerTable;
